import React, { useEffect } from 'react';
import {
    Box,
    CircularProgress,
    IconButton,
    Tooltip, 
} from '@mui/material';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import RouteConstants from '../../constants/routeConstants';
import Title from '../../sharedcomponents/title/title';
 import UserMediaCircuitList from './userMediaCircuitList';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import { Downgraded, useState } from '@hookstate/core'; 
import ExportExcelIcon from '../../sharedcomponents/customIcons/exportExcelIcon';

const ParticipantModuleStatusNew = (props) => {
    // const classes = useStyles();
    const eventInfo = Helper.getStorage('eventInfo');
    const [userModulePermissions, setUserModulePermissions] = React.useState({
        columns: null,
        rows: null,
    });
    const [loading, setLoading] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const inParticiapnt = useState();
    const mediaCircuitActivity = useState();
    // const users = useState([]);
    useEffect(() => {
        getAllData();
    }, []);

    async function getAllData() { 
        let newUserModulePermissions = {
            columns: [],
            rows: [],
        };
 
        setLoading(false);
        ApiHelper.get(APIURLConstants.GET_EVENT_ALL_USER_MOUDLES_STATUS_BY_EVENTID(eventInfo.eventID)).then(
            (res) => {
                if (res.data) {

                    
                    // await Promise.all([modulesInfo, userModulesInfo]).then((result) => {
                    const modules = JSON.parse(res?.data?.headerCount);
                    const users = JSON.parse(res?.data?.usersRecords);
                    // console.log("res.data",modules,users);

                    inParticiapnt.set(users)
                    mediaCircuitActivity.set(modules);
                    if (modules.length > 0 && users.length > 0) {
                        // console.log("modules",modules,"users",users);
                        
                        newUserModulePermissions.columns.push({
                            id: 'userName',
                            label: 'User',
                            ModuleID: 0,
                            showPermission: false,
                            permission: null,
                            align: 'left',
                            completedCount: 0,
                            inCompletedCount: 0,
                            allRequests: 0,
                            userCount: 0,
                            approved:0,
                            inprogress:0,
                            todo:0,
                            rejected:0,
                            total:0
                        });
                        modules.map((item) => {
                            newUserModulePermissions.columns.push({
                                id: item.ModuleName?.toLowerCase(),
                                label: item.ModuleName,
                                ModuleID: item.ModuleID,
                                showPermission: true,
                                permission: null,
                                showLabel: false,
                                align: 'center',
                                completedCount: 0,
                                inCompletedCount: 0,
                                allRequests: item.allRequests ? item.allRequests : 0,
                                userCount: item.userCount ? item.userCount : 0,
                                approved:0,
                                inprogress:0,
                                todo:0,
                                rejected:0,
                                total:0
                            });
                        });

                        let usersData = [];
                        users.map((user) => {
                            // console.log("user",user);
                            
                            let rowObj = {
                                userName: {
                                    label: `${user.LastName}, ${user.FirstName}`,
                                    userID: user.userID,
                                    ModuleID: 0,
                                    showPermission: false,
                                    showLabel: true,
                                    showChips: false,
                                    permission: null,
                                    align: 'left',
                                    approved:0,
                                    inprogress:0,
                                    todo:0,
                                    rejected:0,
                                    total:0
                                },
                            };
                            if (modules) {
                                if (
                                    modules.length > 0 &&
                                    user.Modules.length > 0 &&
                                    user.Modules.length ==
                                    modules.length
                                ) {
                                    let check = {};
                                    user.Modules.forEach((perm) => {
                                        check[perm.permission]
                                            ? check[perm.permission]++
                                            : 0;
                                    });
                                }
                                modules.map((module) => {
                                    // console.log("module",module);
                                    
                                    if (
                                        user.Modules &&
                                        user.Modules.length > 0
                                    ) {
                                        let fIndex =
                                            user.Modules.findIndex(
                                                (row) => {
                                                    return (
                                                        row.ModuleID ==
                                                        module.ModuleID
                                                    );
                                                }
                                            );
                                            // console.log("fIndex",fIndex,user.Modules[fIndex]?.approved,module);
                                            
                                        if (fIndex > -1) {
                                            rowObj[module.ModuleName?.toLowerCase()] = {
                                                label: module.ModuleName,
                                                ModuleID: module.ModuleID,
                                                showPermission: true,
                                                permission:
                                                    user.Modules[
                                                        fIndex
                                                    ].status,
                                                showLabel: false,
                                                showChips: false,
                                                align: 'end',
                                                approved: user.Modules[fIndex]?.approved ?? 0,
                                                inprogress: user.Modules[fIndex]?.inprogress ?? 0,
                                                todo: user.Modules[fIndex]?.todo ?? 0,
                                                rejected: user.Modules[fIndex]?.rejected ?? 0,
                                                total: user.Modules[fIndex]?.totalRequests ?? 0,                                                 
                                            };
                                        } else {
                                            rowObj[module.ModuleName?.toLowerCase()] = {
                                                label: module.ModuleName,
                                                ModuleID: module.ModuleID,
                                                showPermission: false,
                                                permission: null,
                                                showLabel: false,
                                                showChips: false,
                                                align: 'end',
                                                approved:0,
                                                inprogress:0,
                                                todo:0,
                                                rejected:0,
                                                total:0
                                            };
                                        }
                                    } else {
                                        rowObj[module.ModuleName?.toLowerCase()] = {
                                            label: module.ModuleName,
                                            ModuleID: module.ModuleID,
                                            showPermission: false,
                                            permission: null,
                                            showLabel: false,
                                            showChips: false,
                                            align: 'end',
                                            approved:0,
                                            inprogress:0,
                                            todo:0,
                                            rejected:0,
                                            total:0
                                        };
                                    }
                                });
                            }
                            usersData.push(rowObj);
                        });
                        newUserModulePermissions.rows = usersData;
                        setUserModulePermissions(newUserModulePermissions);
                    }
                    else {
                        setUserModulePermissions(newUserModulePermissions);
                    }
                    setLoading(false);
                }
            });
    } 
    // console.log("userModulePermissions",userModulePermissions);
    
    const generateExcelReport = async () => {
        let finalData = [];

        const formatParticipantRow = (data) => {
            const output = {};

            output["Participant"] = data?.userName?.label ?? 'Unknown';

            Object.entries(data).forEach(([key, value]) => {
                if (key === "userName") return;

                const status = [];
                if (value.todo > 0) status.push(`To Do: ${value.todo}`);
                if (value.inprogress > 0) status.push(`Pending: ${value.inprogress}`);
                if (value.approved > 0) status.push(`Approved: ${value.approved}`);
                if (value.rejected > 0) status.push(`Rejected: ${value.rejected}`);

                output[value.label] = status.length > 0 ? status.join(', ') : '';
            });

            return output;
        };

        userModulePermissions.rows.length > 0 && userModulePermissions.rows.map((val) => {
            const formattedRow = formatParticipantRow(val);
            finalData.push(formattedRow);
        })

        //   const formatted = formatParticipantRow(userModulePermissions.rows[0]);
        const allModules = Array.from(
            new Set(
                finalData.flatMap(row => Object.keys(row).filter(key => key !== "Participant"))
            )
        );

        const headers = Object.assign({ Participant: 'Participant' },
            Object.fromEntries(allModules.map(k => [k, k]))
        );
        finalData.unshift(headers);
        Helper.downloadReport(finalData, `ParticipantStatus-Report`);
    };
    //  console.log("userModulePermissions",userModulePermissions);
      

    return (
        <Box sx={{ width: '100%' }}>
            {loading ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                    }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box className="contentBox">
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                        }}>
                        <Title title={'Participant Status'} sx={{ ml: 0, px: 0, }} px={0} />
                        <Tooltip title={'Export Report'}>
                            <>
                                <IconButton
                                    color="primary"
                                    onClick={generateExcelReport}>
                                    <ExportExcelIcon
                                        fontSize="small"
                                        style={{ color: '#008000' }}
                                    />
                                </IconButton>
                            </>
                        </Tooltip>
                    </Box>
                    <UserMediaCircuitList
                        {...props}
                        data={userModulePermissions}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        getAllData={getAllData} 
                    />
                    {/* // ) : (
                    //     <ListItem className={classes.listItemContent}>
                    //         <Card
                    //             classes={{ root: classes.paperContent }}
                    //             sx={{ width: '100%' }}>
                    //             <CardContent
                    //                 sx={{ p: 2 }}
                    //                 className={classes.cardContent}>
                    //                 <Box className={classes.rowContent}>
                    //                     Please select the participant and
                    //                     modules for event
                    //                 </Box>
                    //             </CardContent>
                    //         </Card>
                    //     </ListItem>
                    // )} */} 
                </Box>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};
export default {
    routeProps: {
        path: RouteConstants.EVENT_PARTICIPANT_MODULE_STATUS_NEW,
        component: ParticipantModuleStatusNew,
    },
    name: 'ParticiapntModuleStatusNew',
};
